import { render, staticRenderFns } from "./Suggestions-Card.vue?vue&type=template&id=2c697447&scoped=true&lang=pug"
import script from "./Suggestions-Card.vue?vue&type=script&setup=true&lang=ts"
export * from "./Suggestions-Card.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Suggestions-Card.vue?vue&type=style&index=0&id=2c697447&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c697447",
  null
  
)

export default component.exports